import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-754cf8bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = {
  class: "table-box",
  ref: "table_box"
}
const _hoisted_3 = {
  key: 0,
  class: "row head"
}
const _hoisted_4 = {
  key: 0,
  class: "col float-left",
  style: {"width":"50px","flex-grow":"initial"}
}
const _hoisted_5 = {
  key: 1,
  class: "col float-left",
  style: {"width":"100px","flex-grow":"initial"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "col float-left",
  style: {"width":"50px","flex-grow":"initial"}
}
const _hoisted_8 = {
  key: 1,
  class: "col float-left",
  style: {"width":"100px","flex-grow":"initial"}
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "row sum"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col",
  style: {"width":"100px","flex-grow":"initial"}
}, "合计", -1))
const _hoisted_13 = { class: "page-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_ElemRender = _resolveComponent("ElemRender")!
  const _component_Page = _resolveComponent("Page")!
  const _component_Spin = _resolveComponent("Spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "elem-table",
    style: _normalizeStyle({ height: $props.height, 'max-height': $props.expand ? 'initial' : 'calc(100vh - 80px)' })
  }, [
    ($props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      ($props.head)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            ($props.isSelector)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_Checkbox, {
                    indeterminate: $data.selecteds.length > 0 && $data.tableData.length !== $data.selecteds.length,
                    value: $data.tableData && $data.tableData.length > 0 && $data.tableData.length === $data.selecteds.length,
                    onOnChange: $options.onChangeAllSelector
                  }, null, 8, ["indeterminate", "value", "onOnChange"])
                ]))
              : _createCommentVNode("", true),
            ($props.isIndex)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "序号"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (col, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["col", 'float-' + (col.float || col.fixed)]),
                key: idx,
                style: _normalizeStyle({ width: col._w, 'max-width': col.maxWidth ? col.maxWidth + 'px' : '' })
              }, [
                _createElementVNode("span", null, _toDisplayString(col.title || col.key), 1),
                (typeof col.sort === 'string')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["sort", col.sort === 'asc' ? 'asc' : 'desc']),
                      onClick: ($event: any) => ($options.onChangeSort(col))
                    }, null, 10, _hoisted_6))
                  : _createCommentVNode("", true)
              ], 6))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tableData, (row, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row",
          key: idx
        }, [
          ($props.isSelector)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_Checkbox, {
                  value: $data.selecteds.findIndex(v => v._id === row._id) > -1,
                  onOnChange: ($event: any) => ($options.onChangeSelector($event, row))
                }, null, 8, ["value", "onOnChange"])
              ]))
            : _createCommentVNode("", true),
          ($props.isIndex)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(idx + 1), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (col, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["col", 'float-' + (col.float || col.fixed)]),
              key: idx,
              style: _normalizeStyle({ width: col._w, 'max-width': col.maxWidth ? col.maxWidth + 'px' : '', color: $options.getHighlightColor(col, row), cursor: col.click ? 'pointer' : '' }),
              onClick: ($event: any) => (col.click && col.click({ row, index: idx }))
            }, [
              (col.slot)
                ? _renderSlot(_ctx.$slots, col.slot, {
                    key: 0,
                    row: row,
                    col: col
                  }, undefined, true)
                : (col.render)
                  ? (_openBlock(), _createBlock(_component_ElemRender, {
                      key: 1,
                      render: col.render,
                      row: row,
                      index: idx
                    }, null, 8, ["render", "row", "index"]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      innerHTML: $options.getValue(col, row)
                    }, null, 8, _hoisted_10))
            ], 14, _hoisted_9))
          }), 128))
        ]))
      }), 128)),
      ($props.isIndex && Object.keys($data.sums).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (col, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["col", 'float-' + (col.float || col.fixed)]),
                key: idx,
                style: _normalizeStyle({ width: col._w, 'max-width': col.maxWidth ? col.maxWidth + 'px' : '' })
              }, [
                _createElementVNode("div", null, _toDisplayString(typeof $data.sums[col.key] === "number" ? $data.sums[col.key] : ""), 1)
              ], 6))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _createVNode(_component_Page, {
        current: $data.currentPage,
        onOnPageSizeChange: $options.onChangePageSize,
        "page-size": $data.pageSize,
        "page-size-opts": [20, 50, 100, 500],
        total: $data.total,
        size: "small",
        "show-total": "",
        "show-elevator": "",
        "show-sizer": "",
        onOnChange: $options.onChangePage
      }, null, 8, ["current", "onOnPageSizeChange", "page-size", "total", "onOnChange"])
    ], 512), [
      [_vShow, !!$props.tableApi && !$data.hidePage]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["load-box", { ac: $data.isLoading }])
    }, [
      _createVNode(_component_Spin, { fix: "" })
    ], 2),
    (!$data.tableData || $data.tableData.length == 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "empty-box",
          style: _normalizeStyle({ top: 'calc(50% - 20px + ' + ($props.head ? 21 : 0) + 'px)' })
        }, "暂无数据", 4))
      : _createCommentVNode("", true)
  ], 4))
}